/**
 * Centralized constants for support ticket UI.
 * Use in Form, HelpSupport, SupportTicketList, SupportTicketDetail.
 */

export const PROBLEM_TYPES = [
  'Forgot password',
  'Cannot login / Invalid credentials',
  'Account locked',
  'OTP not received',
  'Other',
];

export const STATUS_OPTIONS = [
  { value: 'OPEN', label: 'Open' },
  { value: 'IN_PROGRESS', label: 'In progress' },
  { value: 'RESOLVED', label: 'Resolved' },
];

export const STATUS_OPTIONS_WITH_ALL = [
  { value: '', label: 'All statuses' },
  ...STATUS_OPTIONS,
];

const STATUS_CONFIG = {
  OPEN: { label: 'Open', color: '#E3F2FD', text: '#1565C0' },
  IN_PROGRESS: { label: 'In progress', color: '#FFF3E0', text: '#E65100' },
  RESOLVED: { label: 'Resolved', color: '#E8F5E9', text: '#2E7D32' },
};

/**
 * @param {string} status - OPEN | IN_PROGRESS | RESOLVED
 * @returns {{ label: string; color: string; text: string }}
 */
export function getStatusConfig(status) {
  return STATUS_CONFIG[status] || { label: status || '–', color: '#F5F5F5', text: '#616161' };
}

/** Max length for description (align with backend DTO). */
export const DESCRIPTION_MAX_LENGTH = 5000;

/** Max length for reply message (align with backend DTO). */
export const REPLY_MAX_LENGTH = 2000;
